import { Check } from "lucide-react";
import { ERROR_CLASS } from "./authFieldStyles";

// Checkbox drawn from scratch: the native box is kept for keyboard and screen
// reader behaviour but made invisible, and the square beside it is styled.
const AuthCheckbox = ({ name, checked, error, onChange, children }) => (
  <div>
    <label htmlFor={name} className="flex cursor-pointer items-start gap-2.5">
      <span className="relative mt-0.5 flex h-4 w-4 shrink-0">
        <input
          type="checkbox"
          id={name}
          name={name}
          checked={checked}
          onChange={onChange}
          className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-gray-300 bg-white transition checked:border-brand-500 checked:bg-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-100"
        />
        <Check
          size={12}
          strokeWidth={3}
          className="pointer-events-none absolute inset-0 m-auto text-white opacity-0 peer-checked:opacity-100"
        />
      </span>

      <span className="text-sm leading-5 text-gray-600">{children}</span>
    </label>

    {error && <p className={ERROR_CLASS}>{error}</p>}
  </div>
);

export default AuthCheckbox;
